export default __webpack_public_path__ + "static/media/12.c26d7944.jpg";